/* React Higher Order Component which fetches project data where projectId = props.projectId
    Child (InnerComponent) will only render once project data is successfully fetched.
    child will receive props: {
        projectId: PropTypes.number,
        projectStoreState: PropTypes.shape({ initialized: PropTypes.bool, project: PropTypes.object, activitySaves: PropTypes.object, ... })
    }

*/

import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');

const Strings = require('../../../../app/shared/Strings');
const ReactUtil = require('../../util/ReactUtil');
const ProjectActions = require('../../actions/ProjectActions');
const ProjectStore = require('../../stores/ProjectStore');
import LoadingMainContent from '../loading/LoadingMainContent';
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    forceRefreshOnMount: PropTypes.bool, // force refresh of project data, even if project store is already initialized
    hideLoadingIcon: PropTypes.bool
};

const defaultProps = {
    forceRefreshOnMount: false,
    hideLoadingIcon: false
};

export default function withProjectData(WrappedComponent) {
    class WithProjectData extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                projectStoreState: ProjectStore.getStateProject(props.projectId),
                getActionId: null,
                fatalError: null,
            };

            this.unsubscribes = [ProjectStore.listen(this.onActivityStoreChange.bind(this))];
        }

        componentDidMount() {
            if (!this.state.projectStoreState.initialized || this.props.forceRefreshOnMount) {
                const actionId = uuid.v4();
                this.setState({ getActionId: actionId }, () => {
                    ProjectActions.getAllProjects(actionId);
                });
            }
        }

        componentWillUnmount() {
            this.unsubscribes.forEach(u => u());
        }

        onActivityStoreChange(newState) {
            let additionalState = {};
            if (newState.action.id === this.state.getActionId) {
                additionalState = { ...additionalState, getActionId: null };
                if (!!newState.action.error) {
                    additionalState = { ...additionalState, fatalError: newState.action.error };
                }

            }

            this.setState({
                projectStoreState: ProjectStore.getStateProject(this.props.projectId),
                ...additionalState
            });
        }

        render() {
            if (this.state.fatalError) {
                return <ErrorBox error={this.state.fatalError} />;
            }

            if (!this.state.projectStoreState.initialized) {
                if (this.props.hideLoadingIcon) {
                    return null;
                }
                else {
                    return <LoadingMainContent />;
                }
            }
            else {
                if (!this.state.projectStoreState.project && !this.state.projectStoreState.shortCourseProject) {
                    return <ErrorBox error={{ message: Strings['en'].error.NOT_FOUND_PROJECT }} />;
                }
            }

            return (
                <WrappedComponent
                    {...this.props}
                    projectStoreState={this.state.projectStoreState}
                />
            );
        }
    }

    WithProjectData.propTypes = propTypes;
    WithProjectData.defaultProps = defaultProps;
    WithProjectData.displayName = `WithProjectData(${ReactUtil.getComponentDisplayName(WrappedComponent)})`
    return WithProjectData;
}
